import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/**
 * 직접 추가 (퀘스트 7ca8908c) — 섭외 IA §3-3.
 *
 * **주 CTA 가 아니다.** 표 아래에 한 줄로 눕고 버튼도 보조 톤이다 — 여기가 눈에 먼저 들어오면
 * 담당자가 조건 조회 대신 손으로 붙여넣기 시작한다.
 */
export const wrap = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

export const row = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.sm,
});

export const label = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const input = style({
  minWidth: '260px',
});

export const error = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.error,
});

export const resolved = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.success,
});

/** 아직 식별 전이다 — 후보가 된 것과 같은 색으로 두면 명단에 있다고 읽힌다. */
export const awaiting = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.warning,
});
